import { omit } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import Table from 'components/shared/table';
import AttendanceRowMultipleColumn from '../AttendanceRowMultipleColumn';
import * as types from '../types';
import ShowMore from './ShowMore';

const Attendances = ({
  attendances,
  currentSessionId,
  isMultiSession,
  loading,
  onShowMore,
  query,
  rsvpType,
  searchResultsFlag,
  sessions,
  updateAttendance,
}) => {
  return (
    <div className="AttendanceTableSection">
      <h4 className="AttendanceTableSection-header">
        {t(
          'in_person_training.event_overview.attendance.matching_guests_title',
          {
            count: attendances.searchCount,
          },
        )}
      </h4>
      {!attendances.data.length && (
        <div className="AttendanceTableSection-placeholder">
          {loading
            ? t('common.loading')
            : t(
                'in_person_training.event_overview.attendance.no_results_for_query',
                { query },
              )}
        </div>
      )}
      {!!attendances.data.length && (
        <Table alternate>
          {searchResultsFlag && isMultiSession && (
            <Table.Header className="EventSessionOverview-attendanceSessionHeader">
              <Table.Body.Cell>
                <div className="d-f jc-l">
                  {t('in_person_training.event_overview.attendances.name')}
                </div>
              </Table.Body.Cell>
              <Table.Body.Cell>
                <div className="d-f jc-l">
                  {currentSessionId &&
                    isMultiSession &&
                    t('in_person_training.attendance.headers.session_rsvp')}
                  {!currentSessionId &&
                    isMultiSession &&
                    t('in_person_training.attendance.headers.event_rsvp')}
                  {!isMultiSession &&
                    t('in_person_training.attendance.headers.rsvp')}
                </div>
              </Table.Body.Cell>
              {(currentSessionId || !isMultiSession) && (
                <Table.Body.Cell>
                  <div className="d-f jc-l">
                    {t('in_person_training.attendance.headers.attendance')}
                  </div>
                </Table.Body.Cell>
              )}
            </Table.Header>
          )}
          {attendances.data.map(attendance => (
            <AttendanceRowMultipleColumn
              currentSessionId={currentSessionId}
              sessions={sessions}
              isMultiSession={isMultiSession}
              updateAttendance={updateAttendance}
              key={attendance.id}
              rsvpType={rsvpType}
              attendance={attendance}
              displayAsSearchResult="true"
              searchResultsFlag={searchResultsFlag}
              rsvpHideAlert={attendances.rsvpHideAlert}
            />
          ))}
        </Table>
      )}
      <ShowMore
        filter={omit('data', attendances)}
        currentTotal={attendances.data.length}
        onClick={onShowMore}
      />
    </div>
  );
};

Attendances.propTypes = {
  attendances: types.MatchedAttendances,
  loading: PropTypes.bool,
  onShowMore: PropTypes.func,
  query: PropTypes.string,
  updateAttendance: PropTypes.func,
};

export default Attendances;
